// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LeiG","top":"styles_top__3vOjB","left":"styles_left__VDZUB","description":"styles_description__su6ox"};